import { Button, TextField } from "@mui/material";
import { useState } from "react";
import { useModal } from "src/components/organisms/context_modal/context_modal";
import { useNotifier } from "src/components/organisms/context_snackbar/context_snackbar";
import { useProblemCookie } from "src/core/problem";

export type ProblemProps = {
  imagePath: string;
  problemID: number;
};

export const Problem = (props: ProblemProps) => {
  const [answer, setAnswer] = useState("");
  const [, setCookie] = useProblemCookie(props.problemID);
  const notifier = useNotifier();
  const modalController = useModal();

  return (
    <div
      style={{
        height: "80vh",
        width: "80vw",
        maxWidth: "1000px",
        display: "flex",
        padding: "10px",
        flexDirection: "column",
      }}
    >
      <h2>Problem {props.problemID}</h2>
      <div>
        <img src={props.imagePath} />
      </div>
      <div style={{ marginTop: "auto", display: "flex", alignItems: "center" }}>
        <TextField
          label="Answer"
          value={answer}
          placeholder="Answer"
          onChange={(event) => {
            setAnswer(event.target.value);
          }}
        />
        <Button
          variant="outlined"
          onClick={() => {
            // TODO if (answer === "correct")
            notifier.notifySuccess("正解です");
            setCookie({
              status: "solved",
            });
            modalController.close();
          }}
        >
        提出
        </Button>
      </div>
    </div>
  );
};
